import { v4 as uuidv4 } from "uuid"
import { addEventToQueue } from "./event-tracker"
import { getSlideshowId } from "./base-tracker"
import { isMobile } from "../utils/breakpoints"

const VIEW_THRESHOLD = 0.5 // The recommendation must be 50% in view before it is tracked

const store = {
  trackedRecs: {},
  viewId: uuidv4(),
  modules: {},
}

const markAsTracked = (id) => {
  store.trackedRecs[id] = true
}

const buildTrackingEvent = (recommendationElement, eventType) => {
  const { index, sourceName, recommendationModulePosition, recId, score } = recommendationElement.dataset

  return {
    eventName: "rec_event_stream",
    eventBody: {
      event: eventType,
      index,
      rec_id: recId,
      view_id: store.viewId,
      slideshow_id: getSlideshowId(),
      source: sourceName,
      score,
      module_position: recommendationModulePosition,
      module_type: store.modules[recommendationModulePosition],
      time_stamp: Date.now(),
      platform: isMobile() ? "mobile_web" : "desktop_web",
    },
  }
}

const onRecommendationClick = (e) => {
  const element = e.currentTarget
  const trackingEvent = buildTrackingEvent(element, "rc")
  addEventToQueue(trackingEvent)
}

const onRecommendationIntersectionChange = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const recommendationElement = entry.target
      const trackingId = recommendationElement.dataset.recId

      if (!store.trackedRecs[trackingId]) {
        const trackingEvent = buildTrackingEvent(recommendationElement, "rv")
        markAsTracked(trackingId)
        addEventToQueue(trackingEvent)
      }
    }
  })
}

const trackRecommendations = () => {
  const observer = new IntersectionObserver(onRecommendationIntersectionChange, {
    root: null, // Track intersection with entire viewport
    threshold: VIEW_THRESHOLD,
  })

  const recommendationNodeList = document.querySelectorAll(".recommendation")

  for (let recommendation of recommendationNodeList) {
    observer.observe(recommendation)
    recommendation.addEventListener("click", onRecommendationClick.bind(recommendation))
  }
}

const storeModuleType = (recommendationModule) => {
  const children = recommendationModule.querySelectorAll(".recommendation")
  if (!children) {
    return
  }

  const firstChild = children[0]
  const position = firstChild.dataset.recommendationModulePosition
  let moduleType = firstChild.dataset.sourceName

  for (let recommendation of children) {
    const childModuleType = recommendation.dataset.sourceName

    if (childModuleType !== moduleType) {
      moduleType = "MULTIPLE_SOURCES"
      break
    }
  }

  store.modules[position] = moduleType
}

const detectModuleTypes = () => {
  const modules = document.querySelectorAll(".recommendation-module")

  for (let recommendationModule of modules) {
    storeModuleType(recommendationModule)
  }
}

if (window.feature_flags.recommendationImpressionTracking) {
  detectModuleTypes()
  trackRecommendations()
}
